<template>
<div class="flex flex-col c-box">
	<div class="header-box">
	      <p class="nowrap" style="width: 90%; margin: 0px auto;">{{title}}</p>
	      <div class="close-box" @click="closePreview">x</div>
	</div>
	<div class="centent-box flex-1 flex">
		<a-table
		        style="text-align: center;margin:0px auto;"
		        :locale="{ emptyText: '暂无数据' }"
		        :columns="columns"
		        :data-source="dataList"
		        :loading="loading"
		         @change="handleTableChange"
		        :pagination="pagination"
		        :bordered="true"
		         rowKey="id"
		         v-if="num=='0' || num=='6'"
		      >
		        <template slot="sequenceNumber" slot-scope="text, record, index">
		          {{ index + 1 }}
		        </template>
		         <template slot="sex" slot-scope="text">
		         	<span v-if="text=='1'">男</span>
		          <span v-else>女</span>
		        </template>
		        <template slot="izResponse" slot-scope="text, record">
		         	<span v-if="record.izResponse=='1'">是</span>
		          <span v-else>否</span>
		        </template>
		</a-table>
		<a-table
		        style="text-align: center;margin:0px auto;"
		        :locale="{ emptyText: '暂无数据' }"
		        :columns="columns"
		        :data-source="dataList"
		        :loading="loading"
		         @change="handleTableChange"
		        :pagination="pagination"
		        :bordered="true"
		         rowKey="id"
		         v-if="num=='1'"
		      >
		        <template slot="sequenceNumber" slot-scope="text, record, index">
		          {{ index + 1 }}
		        </template>
		        <template
		          style="width: 100px"
		          slot="applyFiles"
		          slot-scope="text, record"
		        >
		          <tr
		            v-for="(item, index) in record.lxSubsidyFundCostList"
		            :key="index"
		            :style="
		              index + 1 == record.lxSubsidyFundCostList.length
		                ? ''
		                : 'border-bottom: 1px solid #e8e8e8;'
		            "
		            class="table-tr"
		          >
		            <div class="table-content" :title="item.project">
		              <span>{{ item.project }}</span>
		            </div>
		          </tr>
		          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
		        </template>
		        <template
		          style="width: 100px"
		          slot="amount"
		          slot-scope="text, record"
		        >
		          <tr
		            v-for="(item, index) in record.lxSubsidyFundCostList"
		            :key="index"
		            :style="
		              index + 1 == record.lxSubsidyFundCostList.length
		                ? ''
		                : 'border-bottom: 1px solid #e8e8e8;'
		            "
		            class="table-tr"
		          >
		            <div class="table-content" :title="item.amount">
		              <span>{{ item.amount }}</span>
		            </div>
		          </tr>
		          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
		        </template>
		        <template
		          slot="action"
		          slot-scope="record"
		          style="margin: 0 20px"
		        >
		        </template>
		      </a-table>
		 <a-table
		        style="text-align: center;margin:0px auto;"
		        :locale="{ emptyText: '暂无数据' }"
		        :columns="columns"
		        :data-source="dataList"
		        :loading="loading"
		         @change="handleTableChange"
		        :pagination="pagination"
		        :bordered="true"
		         rowKey="id"
		         v-if="num=='2' || num=='5'"
		      >
		        <template slot="sequenceNumber" slot-scope="text, record, index">
		          {{ index + 1 }}
		        </template>
				 <template
					style="width: 100px"
					slot="partNum"
					slot-scope="text,record"
					>
					<tr
						v-for="(item, index) in record.practiceBaseList"
						:key="index"
						:style="
						index + 1 == record.practiceBaseList.length
							? ''
							: 'border-bottom: 1px solid #e8e8e8;'
						"
						class="table-tr"
					>
						<div class="table-content" :title="item.acquireYear">
						<span>{{ item.acquireYear }}</span>
						</div>
					</tr>
					<span v-if="record.practiceBaseList.length == 0">-</span>
					</template>
					<template
					style="width: 100px"
					slot="capitalSource"
					slot-scope="text, record"
					>
					<tr
						v-for="(item, index) in record.practiceBaseList"
						:key="index"
						:style="
						index + 1 == record.practiceBaseList.length
							? ''
							: 'border-bottom: 1px solid #e8e8e8;'
						"
						class="table-tr"
					>
						<div class="table-content" :title="item.peopleNum">
						<span>{{ item.peopleNum }}</span>
						</div>
					</tr>
					<span v-if="record.practiceBaseList.length == 0">-</span>
					</template>
		      </a-table>
	   <a-table
		        style="text-align: center;margin:0px auto;"
		        :locale="{ emptyText: '暂无数据' }"
		        :columns="columns"
		        :data-source="dataList"
		        :loading="loading"
		         @change="handleTableChange"
		        :pagination="pagination"
		        :bordered="true"
		         rowKey="id"
		         v-if="num==3"
		      >
		        <template slot="sequenceNumber" slot-scope="text, record, index">
		          {{ index + 1 }}
		        </template>
		         <template slot="sex" slot-scope="text">
		         	<span v-if="text=='1'">男</span>
		          <span v-else>女</span>
		        </template>
		        <template slot="izResponse" slot-scope="text">
		         	<span v-if="text=='1'">是</span>
		          <span v-else>否</span>
		        </template>
		      </a-table>
		      <a-table
		        style="text-align: center;margin:0px auto;"
		        :locale="{ emptyText: '暂无数据' }"
		        :columns="columns"
		        :data-source="dataList"
		        :loading="loading"
		         @change="handleTableChange"
		        :pagination="pagination"
		        :bordered="true"
		         rowKey="id"
		         v-if="num==4"
		      >
		        <template slot="sequenceNumber" slot-scope="text, record, index">
		          {{ index + 1 }}
		        </template>
		        <span
		          class="flex flex-around"
		          slot="action"
		          slot-scope="record"
		          style="margin: 0 50px"
		        >
		          <div
		            class="flex align-items-center"
		            style="cursor: pointer"
		            @click="editInfo(record)"
		          >
		            <img class="img-box" src="../../assets/images/img42.png" alt="" />
		            <span>编辑</span>
		          </div>
		          <div
		            class="flex align-items-center"
		            style="cursor: pointer"
		            @click="deleteInfo(record)"
		          >
		            <img class="img-box" src="../../assets/images/img43.png" alt="" />
		            <span>移除</span>
		          </div>
		        </span>
		      </a-table>
	</div>
</div>
</template>

<script>
import { getAction,postAction, putAction,deleteAction} from "@/api/index";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "教师姓名",
    dataIndex: "teacherName",
    id: "teacherName",
    align: "center",
    width: 100,
  },
  {
    title: "性别",
    dataIndex: "sex",
    id: "sex",
    align: "center",
    width: 70,
    scopedSlots: { customRender: "sex" },
  },
  {
    title: "生日",
    dataIndex: "birthday",
    id: "birthday",
    align: "center",
    width: 120,
  },
   {
    title: "职称",
    dataIndex: "professionalTitle_dictText",
    id: "professionalTitle_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "是否思政教师",
    dataIndex: "izPolitical_dictText",
    id: "izPolitical_dictText",
    align: "center",
    width: 130,
   },
   {
    title: "加入年份",
    dataIndex: "joinYear",
    id: "joinYear",
    align: "center",
    width: 100,
   },
   {
    title: "成员来源",
    dataIndex: "memberSource_dictText",
    id: "memberSource_dictText",
    align: "center",
    width: 100,
   },
  {
    title: "是否负责人",
    dataIndex: " izResponse",
    id: "izResponse",
    align: "center",
    scopedSlots: { customRender: "izResponse" },
    width: 130,
  },
];
const columns1 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "资金名称",
    dataIndex: "name",
    id: "name",
    align: "center",
    width: 150,
  },
  {
    title: "资金来源",
    dataIndex: "capitalSource_dictText",
    id: "capitalSource_dictText",
    align: "center",
    width: 250,
  },
  {
    title: "金额",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 150,
  },
// {
//  title: "支出项目",
//  dataIndex: "id",
//  id: "id",
//  align: "center",
//  width: 250,
//  scopedSlots: { customRender: "applyFiles" },
//},
  {
    title: "总支出金额",
    dataIndex: "costAmount",
    id: "costAmount",
    align: "center",
    width: 150,
//  scopedSlots: { customRender: "amount" },
  },
];
const columns2 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "成果名称",
    dataIndex: "title",
    id: "title",
    align: "center",
    width: 270,
  },
  {
    title: "成果获得年份",
    dataIndex: "acquireYear",
    id: "acquireYear",
    align: "center",
    width: 170,
  },
//   {
//     title: "成果类型",
//     dataIndex: "achievementType_dictText",
//     id: "achievementType_dictText",
//     align: "center",
//     width: 150,
//   },
  {
    title: "数量",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 205,
  },
   {
    title: "级别",
    dataIndex: "levelType",
    id: "levelType",
    align: "center",
    width: 205,
  },
];
const columns3 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "基地名称",
    dataIndex: "baseName",
    id: "baseName",
    align: "center",
    width: 200,
  },
  {
    title: "基地建设时间",
    dataIndex: "baseFoundTime",
    id: "baseFoundTime",
    align: "center",
    width: 150,
  },
  {
    title: "省",
    dataIndex: "province_dictText",
    id: "province_dictText",
    align: "center",
    width: 110,
  },
  {
    title: "市",
    dataIndex: "city_dictText",
    id: "city_dictText",
    align: "center",
    width: 110,
  },
  {
    title: "区/县",
    dataIndex: "area_dictText",
    id: "area_dictText",
    align: "center",
    width: 120,
  },
  {
    title: "基地建设地址",
    dataIndex: "baseAddress",
    id: "baseAddress",
    align: "center",
    width: 160,
  },
];
const columns4 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 120,
  },
  {
    title: "活动名称",
    dataIndex: "name",
    id: "name",
    align: "center",
    width: 295,
  },
   {
    title: "年份",
    dataIndex: "activityYear",
    id: "activityYear",
    align: "center",
    width: 230,
  },
  {
    title: "活动分类",
    dataIndex: "type",
    id: "type",
    align: "center",
    width: 275,
  },
//   {
//     title: "活动数量",
//     dataIndex: "num",
//     id: "num",
//     align: "center",
//     width: 225,
//   },
//   {
//     title: "活动名称",
//     dataIndex: "name",
//     id: "name",
//     align: "center",
//     width: 275,
//   },
//   {
//     title: "活动类型",
//     dataIndex: "type",
//     id: "type",
//     align: "center",
//     width: 150,
//   },
//   {
//     title: "活动举办时间",
//     dataIndex: "holdingTime",
//     id: "holdingTime",
//     align: "center",
//     width: 175,
//   },
//    {
//     title: "参与人数",
//     dataIndex: "partNum",
//     id: "partNum",
//     align: "center",
//     width: 150,
//   },
];
const columns5 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "基地名称",
    dataIndex: "baseName",
    id: "baseName",
    align: "center",
    width: 210,
  },
  {
    title: "基地形式",
    dataIndex: "baseForm_dictText",
    id: "baseForm_dictText",
    align: "center",
    width: 150,
  },
  {
    title: "基地类别",
    dataIndex: "baseType_dictText",
    id: "baseType_dictText",
    align: "center",
    width: 150,
  },
  {
    title: "加入时间",
    dataIndex: "cooperativeTime",
    id: "cooperativeTime",
    align: "center",
    width: 120,
  },
   {
    title: "活动年份",
    dataIndex: "partNum",
    id: "partNum",
    scopedSlots: { customRender: "partNum" },
    align: "center",
    width: 100,
  },
  {
    title: "参与人次",
    dataIndex: "createTime",
    id: "createTime",
    scopedSlots: { customRender: "capitalSource" },
    align: "center",
    width: 120,
  },
//   {
//     title: "基地名称",
//     dataIndex: "baseName",
//     id: "baseName",
//     align: "center",
//     width: 180,
//   },
//   {
//     title: "基地形式",
//     dataIndex: "baseForm",
//     id: "baseForm",
//     align: "center",
//     width: 150,
//   },
//   {
//     title: "基地类别",
//     dataIndex: "baseType",
//     id: "baseType",
//     align: "center",
//     width: 150,
//   },
//   {
//     title: "合作时间",
//     dataIndex: "cooperativeTime",
//     id: "cooperativeTime",
//     align: "center",
//     width: 100,
//   },
//   {
//     title: "活动年份",
//     dataIndex: "activityYear",
//     id: "activityYear",
//     align: "center",
//     width: 100,
//   },
//   {
//     title: "参与人次",
//     dataIndex: "partNum",
//     id: "partNum",
//     align: "center",
//     width: 100,
//   },
];
const columns6 = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "教师姓名",
    dataIndex: "teacherName",
    id: "teacherName",
    align: "center",
    width: 150,
  },
  {
    title: "性别",
    dataIndex: "sex",
    id: "sex",
    align: "center",
    width: 90,
    scopedSlots: { customRender: "sex" },
  },
  {
    title: "学历",
    dataIndex: "education_dictText",
    id: "education_dictText",
    align: "center",
    width: 170,
  },
   {
    title: "职称",
    dataIndex: "professionalTitle_dictText",
    id: "professionalTitle_dictText",
    align: "center",
    width: 170,
  },
  {
    title: "是否负责人",
    dataIndex: " izResponse",
    id: "izResponse",
    align: "center",
    scopedSlots: { customRender: "izResponse" },
    width: 150,
  },
   {
    title: "加入年份",
    dataIndex: "joinYear",
    id: "joinYear",
    align: "center",
    width: 120,
   },
];
export default {
	data(){
		return{
			columns:columns,
			dataList:[],
			loading:false,
			pagination: {
		        total: 0,
		        current: 1,
		        pageSize: 5, 
	       },
		}
	},
	props: {
	    title: {
	      type: String,
	      default: '',
	     },
	     num: {
	      type: Number,
	      default: 0
	     },
	     record: {
	      type: Object,
	      default: {},
	    }
	},
	mounted(){
//		console.log(this.num);
		this.pagination.current=1;
		if(this.num=='0'){
			this.columns=columns;
			this.getData();
		}else if(this.num=='1'){
			this.columns=columns1;
			this.getData1();
		}else if(this.num=='2'){
			this.columns=columns2;
			this.getData2();
		}else if(this.num=='3'){
			this.columns=columns3;
			this.getData3();
		}else if(this.num=='4'){
			this.columns=columns4;
			this.getData4();
		}else if(this.num=='5'){
			this.columns=columns5;
			this.getData5();
		}else if(this.num=='6'){
			this.columns=columns6;
			this.getData();
		}
	},
	methods:{
		handleTableChange(pagination) {
	      this.pagination.current = pagination.current;
	      this.pagination.pageSize = pagination.pageSize;
	        if(this.num=='0' || this.num=='6'){
			     this.getData();
					}else if(this.num=='1'){
						this.getData1();
					}else if(this.num=='2'){
						this.getData2();
					}else if(this.num=='5'){
						this.getData5();
					}else if(this.num=='3'){
						this.getData3();
					}else if(this.num=='4'){
						this.getData4();
					}
			      
		 },
    	getData3(){
    		this.loading = true;
    		let applyType=1;
    		 if (this.$route.name === "szStudio") {
	         applyType = 1;
	      } else if (this.$route.name === "educationalBrand") {
	        applyType = 2;
	      } else {
	        applyType = 3;
	      }
		      let data = {
		        applyType: applyType,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxbase/lxApplyBase/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
    	},
    	getData4(){
    		this.loading = true;
    		let applyType=1;
    		 if (this.$route.name === "szStudio") {
	         applyType = 1;
	      } else if (this.$route.name === "educationalBrand") {
	        applyType = 2;
	      } else {
	        applyType = 3;
	      }
		      let data = {
		        applyType: applyType,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxBase/lxApplyActivity/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
    	},
    	getData1(){
    		this.loading = true;
    		let applyType=1;
    		 if (this.$route.name === "szStudio") {
	         applyType = 1;
	      } else if (this.$route.name === "educationalBrand") {
	        applyType = 2;
	      } else {
	        applyType = 3;
	      }
		      let data = {
		        applyType: applyType,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxBase/lxSubsidyFund/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
    	},
    	getData2(){
			this.loading = true;
		      let data = {
		        applyType: 1,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxBase/lxApplyAchievement/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
		  },
		  getData5(){
		  	 this.loading = true;
		      let data = {
		        applyType: 1,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxbase/lxApplyCooperativeBase/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
		  },
    	getData(){
			   this.loading = true;
			   let applyType=1;
	    		 if (this.$route.name === "szStudio") {
		         applyType = 1;
		      } else if (this.$route.name === "educationalBrand") {
		        applyType = 2;
		      } else {
		        applyType = 3;
		      }
		      let data = {
		        applyType:applyType,
		        pageNo: this.pagination.current,
		        pageSize: this.pagination.pageSize,
		        applyId:this.record.id,
		      };
		      getAction('/lxBase/lxApplyGroup/list',data).then((res) => {
		        if (res.code === 200) {
		          let data = res.result.records;
		          if (data) {
		            this.dataList = data;
		            this.pagination.total = res.result.total;
		          }
		        }
		        this.loading = false;
		      });
		},
		closePreview() {
	      this.$emit("closePreview");
	    },
	}
}

</script>

<style scoped lang="scss">
.c-box{
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  /*background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;*/
  .header-box{
  	  height: 60px;
	  line-height: 60px;
	  position: relative;
	  text-align: center;
	  background: #2155B5;
	  /*border-top-left-radius: 15px;
	  border-top-right-radius: 15px;*/
	  /*margin: 0px 19px 0px 9px;*/
	  font-size: 20px;
	  font-family: Microsoft YaHei;
	  font-weight: bold;
	  color: #fff;
  }
  .nowrap{
  	white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
   .close-box{
   	    position: absolute;
	    color: #fff;
	    font-size: 24px;
	    right: 3%;
	    cursor: pointer;
	    top: -2px;
   }
   .centent-box{
	   	/*margin: 0 12px 5px 0;*/
	    padding: 10px 10px;
	    height: 80%;
   }
   .table-tr {
	  width: 100%;
	  display: inline-block;
	  text-align: center;
	  margin: 0 auto;
	  // border-bottom: 1px solid #e8e8e8;
	}
	/deep/.ant-table-tbody > tr > td:nth-child(6),/deep/.ant-table-tbody > tr > td:nth-child(7) {
	  padding: 0 !important;
	  // overflow-wrap: break-word;
	}
	/deep/.ant-table-tbody > tr > td {
	  padding: 0 !important;
	  height: 60px;
	}
	.table-content {
	  margin: 0 auto;
	  height: 60px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  flex-wrap:wrap;
	  width: 100%;
	}
}
</style>